import { axios } from 'apis';
import { RegisterUserData, OrganizationChartNode, Partner } from 'models';


const ENDPOINT = 'Partners';
export const PartnerService = {
	getAll: async () => {
		const response = await axios.get(`${ENDPOINT}`);
		return (await response.data) as Partner[];
	},
	getById: async (id: number) => {
		const response = await axios.get(`${ENDPOINT}/${id}`);
		return (await response.data) as Partner;
	},
	getOrganizationChartForUser: async (userId: number) => {
		const response = await axios.get(`${ENDPOINT}/OrganizationChart/${userId}`);
		return (await response.data) as OrganizationChartNode;
	},
	update: async (data: Partner) => {
		const response = await axios.put(`${ENDPOINT}`, data);
		return (await response.data) as Partner;
	},
	terminate: async (id: number) => {
		await axios.delete(`${ENDPOINT}/${id}`);
	},
	getCurrentPartner: async () => {
		const response = await axios.get(`${ENDPOINT}/CurrentPartner`);
		return (await response.data) as Partner;
	},
	registerUser: async (enrollAcceptedData: RegisterUserData) => {
		await axios.post(`${ENDPOINT}/RegisterUser`, enrollAcceptedData);
	},
	getAllForUser: async (): Promise<Partner[]> => {
		const response = await axios.get(`${ENDPOINT}/ForUser`);
		return response.data;
	},
};